import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { CountryFilterPair, CountryMasterPgsFilterPair, FeatureOption, Option } from '@utils/pageConfig/Types';
import { getPgsBySubscription, getUnavailablePGsByPeriod } from '@utils/productGroupUtils/ProductGroupUtils';
import { checkPeriodValueAndSliceForMATYTD } from '@utils/PeriodUtils';
import { pgsAvailabilityBasedPeriodAndCountry } from '@state/feature/availability-pg/AvailabilityPgSingleCountrySlice';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

export interface PgAvailabilityProps {
  periodValue: string;
  periodicity: Periodicity;
  appliedCountries: Option[];
  pgsByAppliedCountry: CountryFilterPair[];
  countriesPgsAvailabilities: CountryMasterPgsFilterPair[];
  appliedProductGroups: Option[];
  isMultiCountry?: boolean;
  feature?: FeatureOption;
}

export const useDispatchPgsAvailability = (props: PgAvailabilityProps) => {
  const dispatch = useDispatch();

  const {
    periodValue,
    periodicity,
    appliedCountries,
    pgsByAppliedCountry,
    countriesPgsAvailabilities,
    appliedProductGroups,
    isMultiCountry,
    feature,
  } = props;

  useEffect(() => {
    const totalSubscriptionPgs = getPgsBySubscription(
      periodicity,
      pgsByAppliedCountry,
      periodValue,
      appliedCountries,
      appliedProductGroups,
    ).length;

    const unavailablePgs = getUnavailablePGsByPeriod(
      periodValue,
      periodicity,
      pgsByAppliedCountry,
      countriesPgsAvailabilities,
      appliedCountries,
      appliedProductGroups,
    );

    const currentSelectedCountryPgAvailability = countriesPgsAvailabilities.filter((availablePgs) =>
      appliedCountries.some((country) => country.value === availablePgs.country),
    );

    const periodLabel = checkPeriodValueAndSliceForMATYTD(periodValue);
    const totalAvailablePgs = totalSubscriptionPgs - unavailablePgs.length;

    dispatch(
      pgsAvailabilityBasedPeriodAndCountry({
        selectedCountryPgAvailability: currentSelectedCountryPgAvailability,
        periodLabel,
        totalAvailablePgs,
        totalUnavailablePgs: unavailablePgs.length,
        totalSubscriptionPgs,
        unavailablePgs,
        isMultiCountry,
        feature,
      }),
    );
  }, [
    periodValue,
    periodicity,
    appliedCountries,
    pgsByAppliedCountry,
    countriesPgsAvailabilities,
    appliedProductGroups,
    feature,
  ]);
};
